import { useToast } from '@chakra-ui/react';
import { PostDataWrapper } from '@diamond/shared/data-access';
import { Modal, showToast } from '@diamond/shared/ui';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { useMutation } from '@tanstack/react-query';

import { FormAddProduct } from '../../form-add-product';

type Props = {
  activitiesId: string;
  isOpen: boolean;
  onClose: () => void;
  refetch: () => void | Promise<unknown>;
  division?: string;
};

const SUBMIT_ADD_PRODUCT_URL = 'backoffice/order/additional-products/submit';

export function AddProductModal({
  activitiesId,
  isOpen,
  onClose,
  refetch,
  division,
}: Props) {
  const toast = useToast();
  const session = useAuthStore();

  const { postData: postAdditionalProduct } = PostDataWrapper(
    SUBMIT_ADD_PRODUCT_URL,
    session.access_token,
    false,
    'admin'
  );

  const submitNewProduct = useMutation({
    mutationFn: async (payload: unknown) => {
      postAdditionalProduct(payload)
        .then(() => {
          void refetch();
          showToast(toast, 'success', 'Produk baru berhasil ditambahkan!');
          onClose();
        })
        .catch((error: { message?: string }) => {
          showToast(
            toast,
            'error',
            error?.message || 'Gagal menambahkan produk'
          );
          if (
            error?.message === 'Terdapat produk yang sudah ditambahkan ke order'
          ) {
            void refetch();
            onClose();
          }
        });
    },
  });

  return (
    <Modal
      title="Tambah Produk"
      size="2xl"
      name="form-add-product"
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      hideAction
      closeOnOverlayClick={false}
      modalContentProps={{
        maxH: '100%',
        mt: 0,
      }}
    >
      <FormAddProduct
        activitiesId={activitiesId}
        addProductToActivity={submitNewProduct}
        onClose={onClose}
        refetch={refetch}
        division={division}
      />
    </Modal>
  );
}

export default AddProductModal;
